module.exports = __webpack_public_path__ + "static/img/Y2D100.4b1b563.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Y2D100.png
// module id = Lx5S
// module chunks = 2